export enum RoleType {
  Unknown = -1,
  Broker = 1,
  Staff = 2,
  Admin = 3,
  Underwriter=4
}